import { useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { useEffect } from "react";

const useUsersListing = () => {
  const { authData } = useSelector((state) => state.loginSlice);
  const [allUsers, setAllUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [usersPerPage, setUsersPerPage] = useState(10);
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const fetchTenants = async () => {
    setLoader(true);
    try {
      let url = `${endpoint.GET_USERS}?pageSize=${usersPerPage}&pageNumber=${currentPage}`;

      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.success) {
        setAllUsers(response.data.data.users);
        setTotalCount(response.data.data.totalCount);
      }
    } catch (error) {
 
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchTenants();
  }, [usersPerPage, currentPage, debouncedTerm]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    let value = e.target.value;

    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ]*$/.test(value);

    if (!isValid) {
      return;
    }
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (e) => {
    setUsersPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  return {
    allUsers,
    currentPage,
    totalCount,
    searchTerm,
    loader,
    handlePageClick,
    handleSearch,
    usersPerPage,
    openModal,
    setOpenModal,
    fetchTenants,
    userData,
    setUserData,
  };
};

export default useUsersListing;
